module.exports = __webpack_public_path__ + "img/green-3-diamond-open.9df4aafd.svg";